import { FormControl, InputLabel, MenuItem, Select, FormHelperText, InputLabelProps} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFetchData } from "../hooks/useFetchData";
import { TestLanguage } from "../hooks/testLanguage";

const Dropdown = ({ label, value, onChange, error, helperText, url, options }) => {
  const { data } = useFetchData(url ? `https://3dfinal.tanaghomtech.com/public/api/${url}` : null);
  const [lang, setLang] = useState(localStorage.getItem("lang"));

  const items = options || data?.data || [];

  useEffect(() => {
    setLang(localStorage.getItem("lang"));
  }, []);

  return (
    <FormControl InputLabelProps fullWidth error={!!error}>
      <InputLabel style={{ fontFamily: "oswald, cairo" }}>
        {label}
        <span style={{ color: 'red' }}>*</span>
      </InputLabel>
      <Select
        onChange={(e) => onChange(e.target.value)} // Ensure value change is passed
        label={label}
        value={value || ""} // Controlled input
        style={{ fontFamily: "oswald, cairo" }}
      >
        {items?.map((item) => (
          <MenuItem sx={{ fontFamily: "oswald, cairo" }} key={item.id} value={item.id}>
            {url ==="developers"?TestLanguage(item, "developer_name"):TestLanguage(item, "name")}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Dropdown;
